const LightingRender = () => (
  <svg width="18" height="18" viewBox="-1 -1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 6L4.22361 7.44721C4.393 7.786 4.73926 8 5.11803 8H7.88197C8.26074 8 8.607 7.786 8.77639 7.44721L9.5 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 18V9.66667C14 8.58482 13.6491 7.53215 13 6.66667L11.9 5.2C11.3334 4.44458 10.4443 4 9.5 4H3C2.72386 4 2.5 4.22386 2.5 4.5V5.5C2.5 5.77614 2.72386 6 3 6H12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.5 10.5L10 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6.5 11V14M3.5 10.5L2.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default LightingRender;
